import { Intent } from 'enums';
import * as React from 'react';

import { Paragraph as BaseParagraph } from './styles';

interface IProps
  extends Omit<React.HTMLProps<HTMLParagraphElement>, 'ref' | 'as'> {
  // children: string;
  /**
   * Alternative paragraph styles
   */
  intent?: Intent;
  /**
   * Controls the textAlign
   */
  textAlign?: string;
  marginBottom?: string;
}

const Paragraph = ({ ...props }: IProps) => {
  return <BaseParagraph {...props} />;
};

export default Paragraph;
